// project import
import veille from "./veille";
// import home from './home';
import formation from "./formation";
import modules from "./modules";
import casDeComptoir from "./casDeComptoir";
import masterclass from "./masterclass";
import agenda from "./agenda";
import medicaments from "./medicament";
import pathologies from "./pathologies";
import learning from "./learning";
import favorites from "./favorites";
// import profile from './profile';
import newsletter from "./newsletter";
import avis from "./avis";
import library from "./library";

import Support from "./help";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    veille,
    avis,
    medicaments,
    pathologies,

    // experts,
    // institutions,
    formation,
    modules,
    casDeComptoir,
    masterclass,
    agenda,
    learning,
    favorites,
    newsletter,
    library,
    // imeducate,
    Support,
    // profile,
  ],
};

export default menuItems;
